import { CommitmentFocusSummaryDto, FocusDto } from '../coaching-base/general';
import { BehaviourItem } from '../coaching-tags/models/behaviour.coaching.model';
import { SubBehaviourItem } from '../coaching-tags/models/subbehaviour.coaching.model';
import { TagItem } from '../coaching-tags/models/tag.coaching.model';
import { composeTagIdentifierNext } from '../coaching-tags/tags/tags.model';

import { TagInfo } from './commitment/commitment.state';

export function createTagInfo(
    focus: FocusDto,
    behaviours: BehaviourItem[],
    subBehaviours: SubBehaviourItem[],
): TagInfo {
    let behaviour: BehaviourItem = {
        id: null,
        initials: null,
        shortName: null,
        name: 'Not Found',
    };
    let subBehaviour: SubBehaviourItem = {
        ...behaviour,
        behaviourId: null,
    };

    if (focus) {
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        behaviour =
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            behaviours && behaviours.find((e) => e.id === focus.behaviourId);
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        subBehaviour =
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            subBehaviours &&
            subBehaviours.find((e) => e.id === focus.subBehaviourId);
    }

    return { behaviour, subBehaviour, focus };
}

// TODO post-refactor. sync tag.service>tagToTagItem
export function tagToTagItem(
    tag: CommitmentFocusSummaryDto,
    behaviours: BehaviourItem[],
    subBehaviours: SubBehaviourItem[],
): TagItem {
    const output: TagItem = {
        id: tag.focusId,
        identifier: composeTagIdentifierNext(tag),
        name: '',
        tag: { ...tag },
    };

    const parts: Array<BehaviourItem | SubBehaviourItem> = [];

    if (tag.behaviourId != null) {
        behaviours &&
            parts.push(behaviours.find((b) => b.id === tag.behaviourId));
    }

    if (tag.subBehaviourId != null) {
        subBehaviours &&
            parts.push(subBehaviours.find((s) => s.id === tag.subBehaviourId));
    }

    // TODO refactor
    switch (parts.length) {
        case 1:
            // eslint-disable-next-line no-extra-boolean-cast
            if (!!parts[0]) {
                const behaviourName = parts[0].name;

                output.name = behaviourName;
                output.behaviourName = behaviourName;
                output.tooltip = parts[0].name;
            }
            break;
        case 2:
            if (!!parts[0] && !!parts[1]) {
                const behaviourName = parts[0].name;
                const subBehaviourName = parts[1].name;

                output.name = [behaviourName, subBehaviourName].join(' - ');

                output.behaviourName = behaviourName;
                output.subBehaviourName = subBehaviourName;
                output.tooltip = [parts[0].name, parts[1].name].join(' - ');
            }
            break;
    }

    return output;
}
